import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { coolGrey2 } from 'approot/shared/styles/colours.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { skeletonState } from 'approot/shared/styles/transitions.style';
import { flexColumnCss } from 'approot/shared/styles/flex.style';
import {
  ActivityBuilderSlideControlsRow,
  ActivityBuilderSlide,
  ActivityBuilderSlideRow,
} from './activity-builder-slide.style';
import {
  ActivityBuilderCanvas,
  ActivityBuilderContainer,
} from './activity-builder.style';
import {
  ActivityBuilderSlideItems,
  ActivityBuilderSlidesNav,
} from './activity-builder-slides.style';
import { SLIDE_HEIGHT_MINUS_HEADER_FOOTER } from './activity-builder.constants';
import { ActivityBuilderDraftCanvas } from 'approot/activity-builder/draft/activity-builder-draft.style';
import { ActivityBuilderDraftSlidesNav } from 'approot/activity-builder/draft/activity-builder-draft-slides.style';

export const ActivityBuilderSkeleton = styled(ActivityBuilderContainer)``;

export const ActivityBuilderSkeletonSlide = styled(ActivityBuilderSlide)`
  ${skeletonState}
  background-color: ${coolGrey2};
  border: none;
  box-shadow: none;
  height: ${rem(SLIDE_HEIGHT_MINUS_HEADER_FOOTER)};
`;

export const ActivityBuilderSkeletonCanvas = styled(ActivityBuilderCanvas)``;

type ActivityBuilderSkeletonRowProps = {
  $paddingTop?: number;
};
export const ActivityBuilderSkeletonRow = styled.div<ActivityBuilderSkeletonRowProps>`
  ${({ $paddingTop = 0 }) =>
    $paddingTop &&
    `
    padding-top: ${rem($paddingTop)};
  `}

  width: 100%;
`;

export const ActivityBuilderSkeletonSlideRow = styled(
  ActivityBuilderSlideRow
)``;

export const ActivityBuilderSkeletonSlidesNav = styled(
  ActivityBuilderSlidesNav
)``;

export const ActivityBuilderSkeletonSlideItems = styled(
  ActivityBuilderSlideItems
)`
  ${flexColumnCss}
`;

export const ActivityBuilderSkeletonSlideItem = styled.li`
  ${skeletonState}
  border-radius: ${rem(4)};
  background-color: ${coolGrey2};
  margin-bottom: ${rem(spacing16)};
  margin-left: ${rem(spacing16)};
  height: ${rem(80)};
  width: ${rem(132)};
`;

export const ActivityBuilderDraftSkeletonCanvas = styled(
  ActivityBuilderDraftCanvas
)``;

export const ActivityBuilderDraftSkeletonSlidesNav = styled(
  ActivityBuilderDraftSlidesNav
)``;

export const ActivityBuilderSkeletonActivityControl = styled.div`
  ${skeletonState}
  background-color: ${coolGrey2};
  border-radius: ${rem(40)};
  height: ${rem(58)};
  width: ${rem(200)};
`;

export const ActivityBuilderSkeletonActivityControlRow = styled(
  ActivityBuilderSlideControlsRow
)``;
